import React, { useEffect, useRef, useState } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import './light-slide.scss';

const LightSlide = ({ gallery, isStatic }) => {
  const parentRef = useRef(null);
  const [childHeight, setChildHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const newChildHeight = parentRef.current.querySelector('.gatsby-image-wrapper').clientHeight;
      setChildHeight(newChildHeight);
      parentRef.current.style.height = `${newChildHeight}px`;
    };

    updateHeight();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateHeight);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', updateHeight);
      }
    };
  }, [childHeight]);

  return (
    <div className="light-slide" ref={parentRef}>
      <div className="slides">
        {gallery.map((item, i) => (
          <div key={`carousel-app-bold-${i + 1}`} className="slide">
            {isStatic ? <>{item.image}</> : <GatsbyImage image={getImage(item)} alt="Bold" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LightSlide;
